import PropTypes from 'prop-types'

const MAXIMO_DESCRIPCION = 1000

const truncarDescripcion = (texto = '') => texto.slice(0, MAXIMO_DESCRIPCION)

const DescripcionProducto = ({ value, onChange, vieneDeAdministrar }) => {
  const handleOnChange = (e) => {
    const nuevoValor = truncarDescripcion(e.currentTarget.value)

    onChange({
      ...e,
      target: {
        ...e.target,
        value: nuevoValor
      }
    })
  }

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">Máximo {MAXIMO_DESCRIPCION} caracteres</p>
      )}
      <textarea
        name="descripcion"
        value={value}
        onChange={handleOnChange}
        spellCheck="true"
        rows="5"
        maxLength={MAXIMO_DESCRIPCION}
        className="text-area text-area-descripcion"
      />
      <p className="contador-caracteres">
        {value?.length ?? 0}/{MAXIMO_DESCRIPCION}
      </p>
    </>
  )
}
DescripcionProducto.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default DescripcionProducto
